import React, { useState, Suspense, lazy } from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
// First row testimonials with images - updated with unique testimonials for 50+ age group
const firstRowTestimonials = [{
  name: 'Jason, 52',
  image: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: 'I thought my thinning hair was just part of aging. After 3 months with Hair Growth Oil 3.0, my hairline is filling back in. My wife says I look 10 years younger!'
}, {
  name: 'Brian, 58',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: "I've been losing hair for years. Nothing worked until this. Now I'm seeing regrowth I never thought possible. My confidence is back!"
}, {
  name: 'Kevin, 55',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: 'As an executive, my appearance matters. This oil gave me back the thick hair I had in my 30s. Colleagues keep asking what my secret is!'
}, {
  name: 'Ryan, 61',
  image: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: "I was ready to accept baldness. Then I tried Hair Growth Oil 3.0. Four months later, my crown is filling in beautifully. It's never too late!"
}];
// Lazy loaded additional testimonials component
const AdditionalTestimonials = lazy(() => Promise.resolve({
  default: ({
    maleNames
  }) => {
    // Additional testimonials with images - unique for 50+ age group
    const additionalTestimonials = [{
      name: 'Eric, 54',
      image: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
      text: "After 15 years of gradual thinning, I finally found something that works. My hair is thicker than it's been in a decade. My grandkids say Grandpa looks cool again!"
    }, {
      name: 'Scott, 59',
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
      text: 'I was considering hair plugs. Decided to try this first - best decision ever. My hairline is coming back naturally. Saved thousands on surgery!'
    }, {
      name: 'Greg, 63',
      image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
      text: 'I thought hair growth was impossible for me. This Indonesian formula proved me wrong. My temples are filling in and my confidence has skyrocketed!'
    }, {
      name: 'Tim, 56',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
      text: 'I tried everything over the years. This is the only thing that actually worked. My barber noticed the difference before I did. Real results!'
    }];
    // Additional testimonials without images - unique for 50+ age group
    const textOnlyTestimonials = ["I was skeptical, but after 2 months I'm seeing baby hairs where I had none. My wife is amazed at the transformation!", "I thought my hair loss days were behind me - meaning I'd accepted it. This oil brought my hair back to life. Wish I'd found it sooner!", 'I work in sales and looking good matters. This product gave me back my youthful appearance. My sales numbers went up too!', "I was ready to shave it all off. Tried this as a last resort. Now I'm growing hair in places that were bald for 20 years!"];
    return <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-10" data-id="element-182">
          {/* Additional testimonials with images */}
          {additionalTestimonials.map((testimonial, i) => <div key={i} className="border border-gray-200 p-4 rounded-lg" data-id="element-183">
              <div className="flex mb-2" data-id="element-184">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-185" />)}
              </div>
              <div className="flex items-center mb-3" data-id="element-186">
                <div className="w-10 h-10 rounded-full overflow-hidden mr-2" data-id="element-187">
                  <img src={testimonial.image} alt={`${testimonial.name} testimonial`} className="w-full h-full object-cover" loading="lazy" width="40" height="40" decoding="async" data-id="element-188" />
                </div>
                <div data-id="element-189">
                  <p className="text-xs font-bold flex items-center" data-id="element-190">
                    {testimonial.name}
                    <span className="ml-1 flex items-center text-green-600" data-id="element-191">
                      <CheckCircleIcon size={12} className="mr-1" data-id="element-192" /> Verified
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-sm mb-2" data-id="element-193">{testimonial.text}</p>
            </div>)}
          {/* Additional testimonials without images */}
          {textOnlyTestimonials.map((text, i) => <div key={i + 8} className="border border-gray-200 p-4 rounded-lg" data-id="element-194">
              <div className="flex mb-2" data-id="element-195">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-196" />)}
              </div>
              <p className="text-xs font-bold flex items-center mb-2" data-id="element-197">
                {maleNames[i + 8]}
                <span className="ml-1 flex items-center text-green-600" data-id="element-198">
                  <CheckCircleIcon size={12} className="mr-1" data-id="element-199" /> Verified
                </span>
              </p>
              <p className="text-sm mb-2" data-id="element-200">{text}</p>
            </div>)}
        </div>;
  }
}));
export function MoreTestimonials() {
  const [showMoreTestimonials, setShowMoreTestimonials] = useState(false);
  const scrollToProductOptions = () => {
    document.getElementById('product-options')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Array of male names with ages 50+
  const maleNames = ['Michael, 51', 'David, 57', 'James, 54', 'Robert, 60', 'John, 53', 'William, 58', 'Richard, 62', 'Thomas, 55', 'Charles, 59', 'Joseph, 56', 'Christopher, 52', 'Daniel, 61', 'Matthew, 54', 'Anthony, 58', 'Mark, 63', 'Donald, 65', 'Steven, 57', 'Paul, 60', 'Andrew, 53', 'Joshua, 51'];
  // Second row testimonials - unique for each person
  const secondRowTestimonials = ['My doctor recommended this after seeing my results. The natural ingredients work without any side effects. Highly recommend!', "I've spent thousands on treatments that didn't work. This affordable oil delivered better results than expensive procedures. Incredible!", "My hair was so thin you could see my scalp. Now it's thick enough that my hairstylist can actually style it again. Life-changing!", "I started using this before my daughter's wedding. By the big day, my hair looked fuller and healthier. Perfect timing!"];
  return <section className="w-full py-12 bg-white px-4" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-203">
          More Success Stories
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-10" data-id="element-204">
          {/* First row with images */}
          {firstRowTestimonials.map((testimonial, i) => <div key={i} className="border border-gray-200 p-4 rounded-lg" data-id="element-205">
              <div className="flex mb-2" data-id="element-206">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-207" />)}
              </div>
              <div className="flex items-center mb-3" data-id="element-208">
                <div className="w-10 h-10 rounded-full overflow-hidden mr-2" data-id="element-209">
                  <img src={testimonial.image} alt={`${testimonial.name} testimonial`} className="w-full h-full object-cover" loading="lazy" width="40" height="40" decoding="async" data-id="element-210" />
                </div>
                <div data-id="element-211">
                  <p className="text-xs font-bold flex items-center" data-id="element-212">
                    {testimonial.name}
                    <span className="ml-1 flex items-center text-green-600" data-id="element-213">
                      <CheckCircleIcon size={12} className="mr-1" data-id="element-214" /> Verified
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-sm mb-2" data-id="element-215">{testimonial.text}</p>
            </div>)}
          {/* Second row without images - unique testimonials */}
          {secondRowTestimonials.map((text, i) => <div key={i + 4} className="border border-gray-200 p-4 rounded-lg" data-id="element-216">
              <div className="flex mb-2" data-id="element-217">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-218" />)}
              </div>
              <p className="text-xs font-bold flex items-center mb-2" data-id="element-219">
                {maleNames[i + 4]}
                <span className="ml-1 flex items-center text-green-600" data-id="element-220">
                  <CheckCircleIcon size={12} className="mr-1" data-id="element-221" /> Verified
                </span>
              </p>
              <p className="text-sm mb-2" data-id="element-222">{text}</p>
            </div>)}
        </div>
        {/* Show More Button */}
        {!showMoreTestimonials && <div className="text-center mb-10" data-id="element-223">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full" onClick={() => setShowMoreTestimonials(true)} data-id="element-224">
              Show More
            </button>
          </div>}
        {/* Additional testimonials that show when button is clicked */}
        {showMoreTestimonials && <Suspense fallback={<div className="h-40 w-full bg-gray-100 animate-pulse rounded-lg" data-id="element-226"></div>} data-id="element-225">
            <AdditionalTestimonials maleNames={maleNames} data-id="element-227" />
          </Suspense>}
        {/* Trusted By Section */}
        <div className="border border-gray-200 rounded-lg p-6 mb-10" data-id="element-228">
          <div className="flex flex-col md:flex-row items-center" data-id="element-229">
            <div className="md:w-3/5 mb-6 md:mb-0 pr-0 md:pr-8" data-id="element-230">
              <h3 className="text-xl font-bold mb-3" data-id="element-231">
                Trusted by 74,000+ Men Fighting Hair Loss
              </h3>
              <p className="text-lg italic mb-3" data-id="element-232">
                "Our Indonesian formula has revolutionized hair growth by
                addressing the root causes of baldness that other solutions
                miss"
              </p>
              <p className="text-sm text-gray-600" data-id="element-233">
                Dr. John Nash, Hair Loss Specialist and Formulator
              </p>
            </div>
            <div className="md:w-2/5" data-id="element-234">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6vLmTv3pCETysP9mSkHdPQ/ChatGPT_Image_20_%CE%A3%CE%B5%CF%80_2025%2C_07_33_48_%CE%BC.%CE%BC..webp" alt="Doctor Approved Hair Loss Solution" className="rounded-lg max-w-full h-auto" loading="lazy" width="400" height="300" data-id="element-235" />
            </div>
          </div>
          <div className="mt-8" data-id="element-236">
            <p className="text-center font-bold mb-4" data-id="element-237">As seen on</p>
            <div className="grid grid-cols-1 gap-4 items-center justify-items-center" data-id="element-238">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hWvqJgLpYTQEDFVanWBZKh/1744811807-logo_%281%29.webp" alt="Media logos including NBC, ABC, CBS, FOX NEWS, DIGITAL JOURNAL, USA TODAY" className="h-auto max-w-full" loading="lazy" width="800" height="100" data-id="element-239" />
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-240">
          <h3 className="text-xl font-bold mb-6" data-id="element-241">
            Your Choice: Keep Losing Hair or Take Action Today
          </h3>
          <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full mb-6" onClick={scrollToProductOptions} data-id="element-242">
            CLAIM MY HAIR GROWTH OIL 3.0 NOW
          </button>
          <p className="text-sm text-gray-600" data-id="element-243">
            *These statements have not been evaluated by the FDA. This product
            is not intended to diagnose, treat, cure or prevent any disease.
            Individual results may vary.
          </p>
        </div>
      </div>
    </section>;
}
export default {
  MoreTestimonials
};